import {
  Button,
  FormLabel,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { changePasswordRequest } from "../../modules/auth/Actions";

const PasswordField = ({ label, placeholder, value, onChange, showPassword }) => (
  <FormLabel w="100%" mb={0}>
    {label}
    <Input
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      mt={2}
      required
    />
  </FormLabel>
);

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const resetForm = () => {
    setOldPassword("");
    setNewPassword("");
    setPasswordConfirmation("");
    setShowPassword(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPassword !== passwordConfirmation) {
      toast.error("كلمة المرور الجديدة غير متطابقة");
      return;
    }

    const formData = new FormData();
    formData.append("old_password", oldPassword);
    formData.append("new_password", newPassword);
    formData.append("new_password_confirmation", passwordConfirmation);

    dispatch(
      changePasswordRequest(formData, () => {
        handleClose();
      })
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>تغيير كلمة المرور</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <VStack spacing={4}>
              <PasswordField
                label="كلمة المرور الحالية"
                placeholder="أدخل كلمة المرور الحالية"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                showPassword={showPassword}
              />
              <PasswordField
                label="كلمة المرور الجديدة"
                placeholder="أدخل كلمة المرور الجديدة"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                showPassword={showPassword}
              />
              <PasswordField
                label="تأكيد كلمة المرور الجديدة"
                placeholder="أعد إدخال كلمة المرور الجديدة"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                showPassword={showPassword}
              />
              <Button
                type="button"
                variant="ghost"
                color="main_1"
                alignSelf="flex-start"
                leftIcon={
                  <Icon as={showPassword ? BiLowVision : BiShow} fontSize="18px" />
                }
                onClick={() => setShowPassword((current) => !current)}
              >
                {showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
              </Button>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={handleClose}>
              إلغاء
            </Button>
            <Button
              type="submit"
              bg="main_1"
              color="white"
              isLoading={isLoading}
              _hover={{ bg: "main_1" }}
            >
              حفظ
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default ChangePasswordModal;
